import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { IconButton } from '@studio/legacy-components';
import { selectInstalledDomain } from 'next/entities/installed';

import { URLItemWrapper, URLLabel, QualifiedIcon, URLTooltip } from './styled';

export function UrlListItem({ url, qualified, onRemove, installed }) {
  const tooltipLabel = qualified
    ? installed
      ? 'Will show'
      : 'Will show when installed'
    : 'Will not show';
  return (
    <URLItemWrapper key={url} $installed={installed} $qualified={qualified}>
      <URLTooltip size="s" wrapped label={tooltipLabel}>
        <QualifiedIcon
          aria-label={tooltipLabel}
          icon={qualified ? 'check-circle' : 'times-circle'}
        />
      </URLTooltip>
      <URLLabel>{url}</URLLabel>
      <IconButton onClick={onRemove} icon="trash-alt" aria-label="remove url" />
    </URLItemWrapper>
  );
}

UrlListItem.propTypes = {
  url: PropTypes.string,
  qualified: PropTypes.bool,
  onRemove: PropTypes.func,
  installed: PropTypes.bool,
};

const mapStateToProps = (state, { url }) => {
  const { hostname } = new URL(url);
  return { installed: !!selectInstalledDomain(state, hostname) };
};

export default connect(mapStateToProps)(UrlListItem);
